import { useLocales } from "@/locales";
import { CommonWrap, ComomonAlert } from "@/PageComponents/common";
import ContentWrap from "@/DocLayout/Content/Index";
import { Box } from "@mui/material";

export default function VisitLimit() {
  const { translate } = useLocales();
  return (
    <ContentWrap
      leftChildren={
        <CommonWrap>
          <>
            <Box component={"div"} className="title_0" id="request-limits">
              {translate("faq.visit_limit_title")}
            </Box>
            <Box component={"div"} className="desc">
              {translate("faq.visit_limit_desc")}
            </Box>
            <ComomonAlert>
              {translate("faq.visit_limit_tip_desc1")}
              <br />
              {translate("faq.visit_limit_tip_desc2")}
            </ComomonAlert>
          </>
        </CommonWrap>
      }
    />
  );
}
